import React, { Component } from "react";
import ajax from "superagent";
import _ from "lodash"; // TODO: load only what's needed form lodash-es
import "../styles/style.css";
import "../styles/prepaid-auth.css";
import EventContainer from "./EventContainer";
import EmbedHeader from "./EmbedHeader";
import PrepaidCustomerAuthPopup from "./PrepaidCustomerAuthPopup";
import StyleOverrides from "./StyleOverrides";
import ahoy from "ahoy.js";
import {
  getParameterByName,
  withCartIdParam,
  removeParam,
  getCookie
} from "../../../utils/BrowserHelper";
import getAlbumId from "../../../utils/GetAlbumId";
import PropTypes from "prop-types";
import ShareSocialPopup from "../../ShareSocialPopup/index";
import { Album, Event, Cart } from "./types";
import BundleMediaSelect from "./albums/BundleSelectMedia";
import BulkTagging from "./BulkTagging";
import Photo from "./albums/Photo";
import DeletePhotosConfirmation from "./DeletePhotosConfirmation";
import ShareIcon from "./vectors/ShareIcon";
import PublishBanner from "../../PublishBanner";
import PublishingOptions from "../../PublishingOptions";
import PromptClearPrepaidCart from "./offerBanners/PromptClearPrepaidCart";
import EventSupportEmailPopup from "./EventSupportEmailPopup";
import SaveCart from "../../SaveCartEmailPopup";
import InvitePhotographerPopup from "../../common/InvitePhotographerPopup";
import Telemetry from "../../../utils/rudderstackAnalytics";
import { updateCartItems } from "../../CheckoutPage/components/api";
const wave = require("../../common/images/wave.svg");

interface BrowseEventProps {
  event: Event;
  prepaidCustomer: {
    firstName: string;
    lastName: string;
    email: string;
    eventId: number;
    freePhotosAvailable: number;
  };
  userId: number;
  favoritesGuestUserId: number;
  albumsAPI: string;
  addToCartAPI: string;
  emptyCartAPI: string;
  removeFromCartAPI: string;
  registerCustomerLeadAPI: string;
  registerGuestUserAPI: string;
  addPhotoToFavoritesAPI: string;
  removePhotoFromFavoritesAPI: string;
  userSignedIn: boolean;
  userEmail: string;
  cart: Cart;
  initialFilters: object;
  currentUserHasPasswordAccess: boolean;
  enableFilterByText: boolean;
  selfieSearchS3Bucket: string;
  embedded: boolean;
  ios: boolean;
  mobile: boolean;
  photoTimeRange: {
    min: number;
    max: number;
  };
  cookieInjectURL: string;
  uploadInProgress: boolean;
  eventAnalyticsEventsAPI: string;
  eventAnalyticsVisitsAPI: string;
  authenticatePrepaidCustomerAPI: string;
  createPrepaidCustomerAPI: string;
  promptPrepaidAuth: boolean | string;
  logoutPrepaidCustomerAPI: string;
  unlinkPrepaidCustomerAPI: string;
  pageConfiguration: {
    primaryColor: string;
    secondaryColor: string;
    accentColor: string;
  };
  photoBundleDiscountAvailable: boolean;
  availPhotoBundleDiscountAPI: string;
  withdrawPhotoBundleDiscountAPI: string;
  securedGalleryView: boolean;
  photosAvailable: boolean;
  isAuthorizedForDirectDownloads: boolean;
  eventPassword: string | null;
  authenticateEventPasswordAPI: string;
  galleryURL: string;
  directDownloadEnabled: boolean;
  endUserDownloadsDisabled: boolean;
  organizationId: number;
  canManageTags: boolean;
  canDeletePhotos: boolean;
  schoolUser: boolean;
  publicSharingDisabled: boolean;
  eventPasswordsDisabled: boolean;
  addAllToCartAPI: string;
  hideUploadSelfie: boolean;
  customerCartEmailEnabled: boolean;
  showInvitePhotographerModal: boolean;
  isCustomerOnly: boolean;
  cookiePrepaidAvailed: boolean;
  cookiePrepaidPhotosAvailed: number;
  organisationLogo: string | null;
  printProductsWithDiscounts?: Array<{ id: number; title: string; discountTiers: Array<{ minQuantity: number; kind: "percentage" | "price"; value: number }> }>;
}

interface BrowseEventState {
  cart: Cart;
  prepaidCustomer: {
    firstName: string;
    lastName: string;
    email: string;
    eventId: number;
    freePhotosAvailable: number;
  };
  selfieUploadPopup: boolean;
  promptPrepaidAuth: boolean | string;
  publishState: string;
  discountMessage: string;
  showShareGalleryModal: boolean;
  curationMode: boolean;
  listOfMediaId: Array<{ id: number; hidden: boolean }>;
  showBulkTagging: boolean;
  filterActive: boolean;
  visiblePhotos: Photo[];
  selectAll: boolean;
  deletePhotosPopup: boolean;
  reset: boolean;
  publishPopup: boolean;
  selfiePrepaidStatus: string;
  clearPrepaidCartPopup: boolean;
  clearCartPopup: boolean;
  showEmailpopup: boolean;
  cartHasDiscount: boolean;
  offerEndsText: string | null;
  guestUserId: null | number;
  isProtected: boolean;
  albumModeID: string | null;
  album: Album[] | null;
  filterSelection: null | {
    albums?: Array<{}>;
    referenceImage?: string | null;
  };
  showSaveCartModal: boolean;
  showInvitePopup: boolean;
  isSidebarOpen: boolean;
  guestUserEmail: string;
  // Currently photo is typed as any across the BrowseEvent component
  // TODO: Fix this
  photoAddedToCart: any;
  pendingCartItem: any;
  prepaidSelfieUrl: string | null;
}

export default class BrowseEvent extends Component<
  BrowseEventProps,
  BrowseEventState
> {
  private eventContainerRef = React.createRef<EventContainer>();

  static childContextTypes = {
    currentUserHasPasswordAccess: PropTypes.bool,
    enableFilterByText: PropTypes.bool,
    selfieSearchS3Bucket: PropTypes.string,
    iosEmbed: PropTypes.bool,
    uploadInProgress: PropTypes.bool,
    prepaidCustomer: PropTypes.shape({
      firstName: PropTypes.string,
      lastName: PropTypes.string,
      email: PropTypes.string,
      eventId: PropTypes.number,
      freePhotosAvailable: PropTypes.number
    }),
    cartPrepaidPhotos: PropTypes.array,
    cartPhotos: PropTypes.array,
    cartSales: PropTypes.array,
    freeShippingEarned: PropTypes.bool,
    freeShippingAmountNeeded: PropTypes.string,
    arePrepaidPhotosAvailable: PropTypes.func,
    pageConfiguration: PropTypes.shape({
      primaryColor: PropTypes.string,
      secondaryColor: PropTypes.string,
      accentColor: PropTypes.string
    }),
    cartId: PropTypes.number,
    isEmbed: PropTypes.bool,
    curatePhotos: PropTypes.func,
    reLoadAlbumPhotos: PropTypes.func,
    photoBundleDiscountEventId: PropTypes.number,
    hidePhotographersFilter: PropTypes.bool,
    isAuthorizedForDirectDownloads: PropTypes.bool,
    userId: PropTypes.number,
    eventPassword: PropTypes.string,
    authenticateEventPasswordAPI: PropTypes.string,
    selfieUploadPopup: PropTypes.bool,
    organizationId: PropTypes.bool,
    canManageTags: PropTypes.bool,
    clearMediaIds: PropTypes.func,
    selectAll: PropTypes.bool,
    visiblePhotos: PropTypes.array,
    getPhotoId: PropTypes.func,
    setPhotos: PropTypes.func,
    reset: PropTypes.bool,
    resetPhotos: PropTypes.func,
    curationMode: PropTypes.bool,
    setSelectAll: PropTypes.func,
    selfiePrepaidStatus: PropTypes.string,
    showPrepaidClearCartWarning: PropTypes.bool,
    promptClearPrepaidCart: PropTypes.func,
    addAllToCart: PropTypes.func,
    hideUploadSelfie: PropTypes.bool,
    authenticationDone: PropTypes.func,
    setFilterSelections: PropTypes.func,
    albumModeID: PropTypes.string,
    customerCartEmailEnabled: PropTypes.bool,
    cookiePrepaidAvailed: PropTypes.bool,
    cookiePrepaidPhotosAvailed: PropTypes.number,
    addPhotoToFavoritesAPI: PropTypes.string,
    removePhotoFromFavoritesAPI: PropTypes.string,
    guestUserId: PropTypes.number,
    directDownloadEnabled: PropTypes.bool,
    endUserDownloadsDisabled: PropTypes.bool,
    setGuestUserCart: PropTypes.func,
    registerGuestUserAPI: PropTypes.string,
    setGuestUser: PropTypes.func,
    securedGalleryView: PropTypes.bool,
    canShowEmailPopup: PropTypes.func,
    showSaveCartModalWithItem: PropTypes.func,
    printProductsWithDiscounts: PropTypes.array,
    prepaidSelfieUrl: PropTypes.string
  };
  constructor(props: BrowseEventProps) {
    super(props);
    this.state = {
      cart: props.cart,
      selectAll: false,
      listOfMediaId: [],
      prepaidCustomer: this.props.prepaidCustomer,
      selfieUploadPopup: false,
      discountMessage: "",
      offerEndsText: null,
      showShareGalleryModal: false,
      showBulkTagging: false,
      curationMode: false,
      filterActive: false,
      deletePhotosPopup: false,
      visiblePhotos: [],
      publishState: this.props.event.publishMode,
      reset: false,
      publishPopup: false,
      guestUserId: null,
      albumModeID: null,
      promptPrepaidAuth:
        getParameterByName("prepaid-auth") ||
        (this.props.event.prepaidCustomersEnabled &&
          !this.props.prepaidCustomer &&
          this.props.promptPrepaidAuth),
      selfiePrepaidStatus: this.defaultSelfiePrepaidStatus(),
      clearPrepaidCartPopup: false,
      showEmailpopup: false,
      clearCartPopup:
        window.location.href.includes("clear-cart-prompt=true") || false,
      isProtected: this.props.event.isProtected,
      filterSelection: { referenceImage: this.getReferenceImage() },
      album: null,
      showSaveCartModal: false,
      showInvitePopup: false,
      isSidebarOpen: false,
      guestUserEmail: "",
      pendingCartItem: null,
      prepaidSelfieUrl: (
        this.props.event.prepaidCustomersEnabled &&
        this.props.event.prepaidCustomersPrimaryAuthField === "selfie" &&
        this.props.prepaidCustomer
      ) ? this.getReferenceImage() : null
    };

    $("body").on("contextmenu", function (e) {
      return false;
    });

    ahoy.configure({
      eventsUrl: props.eventAnalyticsEventsAPI,
      visitsUrl: props.eventAnalyticsVisitsAPI,
      trackVisits: true
    });

    ahoy.trackView({ event_id: props.event.id });
  }
  authenticationDone = () => this.setState({ isProtected: false });
  setFilterSelections = (val: { referenceImage: string }) =>
    this.setState({
      filterSelection: val
    });

  arePrepaidPhotosAvailable = () => {
    if (!this.state.prepaidCustomer) return false;
    if (!this.props.event.prepaidCustomersHardLimitEnabled) return true;

    if (this.prepaidAuthCookie()) {
      if (this.props.cookiePrepaidPhotosAvailed)
        return (
          this.state.cart.prepaidPhotos.length <
          this.props.event.prepaidCustomersPhotoLimit -
            this.props.cookiePrepaidPhotosAvailed
        );
      else {
        return (
          this.state.cart.prepaidPhotos.length <
          this.props.event.prepaidCustomersPhotoLimit
        );
      }
    }
    return (
      this.state.cart.prepaidPhotos.length <
      this.state.prepaidCustomer.freePhotosAvailable
    );
  };

  getChildContext() {
    return {
      currentUserHasPasswordAccess: this.props.currentUserHasPasswordAccess,
      curatePhotos: () => this.curatePhotos(),
      enableFilterByText: this.props.enableFilterByText,
      selfieSearchS3Bucket: this.props.selfieSearchS3Bucket,
      iosEmbed: this.props.embedded && this.props.ios,
      uploadInProgress: this.props.uploadInProgress,
      prepaidCustomer: this.state.prepaidCustomer,
      selectAll: this.state.selectAll,
      cartPrepaidPhotos: this.state.cart ? this.state.cart.prepaidPhotos : null,
      cartPhotos: this.state.cart?.photos || [],
      cartSales: this.state.cart?.sales || [],
      freeShippingEarned: this.state.cart?.freeShippingEarned || false,
      freeShippingAmountNeeded: this.state.cart?.freeShippingAmountNeeded || null,
      printProductsWithDiscounts: this.props.printProductsWithDiscounts || [],
      arePrepaidPhotosAvailable: () => this.arePrepaidPhotosAvailable(),
      pageConfiguration: this.props.pageConfiguration,
      cartId: this.state.cart ? this.state.cart.id : null,
      isEmbed: this.props.embedded,
      reset: this.state.reset,
      reLoadAlbumPhotos: () => this.reLoadAlbumPhotos(),
      resetPhotos: () => this.setState({ reset: false }),
      photoBundleDiscountEventId: this.state.cart
        ? this.state.cart.photoBundleDiscountEventId
        : null,
      hidePhotographersFilter: this.props.event.hidePhotographersFilter,
      isAuthorizedForDirectDownloads: this.props.isAuthorizedForDirectDownloads,
      userId: this.props.userId,
      eventPassword: this.props.eventPassword,
      authenticateEventPasswordAPI: this.props.authenticateEventPasswordAPI,
      selfieUploadPopup: this.state.selfieUploadPopup,
      organizationId: this.props.organizationId,
      canManageTags: this.props.canManageTags,
      clearMediaIds: () => this.clearMediaIds(),
      curationMode: this.state.curationMode,
      visiblePhotos: this.state.visiblePhotos,
      setSelectAll: () => this.setSelectAll(),
      setPhotos: (val: any) => this.setPhotos(val),
      getPhotoId: (
        photo: {
          id: number;
          hidden: boolean;
        },
        index: any,
        photos: any
      ) => this.getPhotoId(photo, index, photos),
      selfiePrepaidStatus: this.state.selfiePrepaidStatus,
      showPrepaidClearCartWarning: this.showPrepaidClearCartWarning(),
      promptClearPrepaidCart: this.promptClearPrepaidCart,
      addAllToCart: this.addAllToCart,
      hideUploadSelfie: this.props.hideUploadSelfie,
      authenticationDone: this.authenticationDone,
      setFilterSelections: this.setFilterSelections,
      albumModeID: this.state.albumModeID,
      cookiePrepaidAvailed: this.props.cookiePrepaidAvailed,
      cookiePrepaidPhotosAvailed: this.props.cookiePrepaidPhotosAvailed,
      addPhotoToFavoritesAPI: this.props.addPhotoToFavoritesAPI,
      removePhotoFromFavoritesAPI: this.props.removePhotoFromFavoritesAPI,
      guestUserId: this.state.guestUserId,
      directDownloadEnabled: this.props.directDownloadEnabled,
      endUserDownloadsDisabled: this.props.endUserDownloadsDisabled,
      setGuestUserCart: this.setGuestUserCart,
      setGuestUser: this.setGuestUser,
      registerGuestUserAPI: this.props.registerGuestUserAPI,
      securedGalleryView: this.props.securedGalleryView,
      canShowEmailPopup: this.canShowEmailPopup,
      showSaveCartModalWithItem: (photo: any, cartItem: any) =>
        this.showSaveCartModalWithItem(photo, cartItem),
      prepaidSelfieUrl: this.state.prepaidSelfieUrl
    };
  }

  showPrepaidClearCartWarning = () => {
    return (
      this.props.event.prepaidCustomersPrimaryAuthField == "selfie" &&
      this.props.event.prepaidCustomersEnabled &&
      !!this.state.cart &&
      (this.state.cart.photos?.length || 0) > 0
    );
  };

  defaultSelfiePrepaidStatus = () => {
    if (this.props.event.prepaidCustomersPrimaryAuthField == "selfie") {
      if (this.props.prepaidCustomer) return "available";
    }
    return "unavailable";
  };

  setPhotos = (val: any) => {
    this.setState({
      visiblePhotos: val
    });
  };

  promptClearPrepaidCart = () => {
    this.setState({
      clearPrepaidCartPopup: true
    });
  };

  setSelectAll = () => this.setState({ selectAll: false });

  setFilterActive = (val: boolean) => this.setState({ filterActive: val });

  setSelfieUploadPopup = (value: boolean) => {
    this.setState({ selfieUploadPopup: value });
  };

  discountMessage = () => {
    if (this.props.event.hasDiscount) {
      ajax
        .get(
          withCartIdParam(
            this.props.event.discountStatusPath,
            this.state.cart ? this.state.cart.id : null
          )
        )
        .then(res => {
          this.setState({
            discountMessage: res.body.message,
            cartHasDiscount: res.body.cart_has_discount,
            offerEndsText: res.body.offer_ends_text || null
          });
        });
    }
  };

  checkDiscountAndGetStatus = () => {
    if (this.props.event.hasDiscount) {
      this.discountMessage();
    }
  };

  componentDidMount() {
    // @ts-ignore
    this.setState({ albumModeID: getAlbumId() });
    this.props.userSignedIn &&
      getParameterByName("sidebar") &&
      window.innerWidth > 992 &&
      this.toggleSideBar();
    this.checkDiscountAndGetStatus();
    $("#browse-event").ready(() => {
      $("#browse-event-placeholder").hide();
    });
    if (this.props.favoritesGuestUserId) {
      this.setState({ guestUserId: this.props.favoritesGuestUserId });
    }
    if (this.props.showInvitePhotographerModal) {
      Telemetry.track("internal-referrals:event-gallery-ph-referral-btn-shown");
    }
    if (this.showGalleryActions() && this.props.canManageTags) {
      Telemetry.track("curate-btn-shown");
    }
  }

  bundleDiscountAvailedFromAnotherEvent = (photo: any) =>
    this.state.cart &&
    this.state.cart.photoBundleDiscountAvailed &&
    this.state.cart.photoBundleDiscountEventId != photo.album.eventId;

  isCurrencyMismatch = () => {
    if (
      this.state.cart &&
      this.props.event.currency !== this.state.cart.currency &&
      (this.state.cart.photos?.length || 0) > 0
    ) {
      //@ts-ignore
      toastr.error(
        `The cart can only contain photos in one currency, currently ${this.props.event.currency}. Clear and try adding again.`
      );
      return true;
    }
    return false;
  };

  isBundleDiscountRestricted = (photo: Photo) => {
    if (
      this.bundleDiscountAvailedFromAnotherEvent(photo) &&
      this.state.cart &&
      (this.state.cart.photos?.length || 0) > 0
    ) {
      //@ts-ignore
      toastr.error(
        `You have an active package discount applied. This feature does not permit photos to be added from multiple events. Please clear cart or remove offer before proceeding.`,
        { timeOut: 9500 }
      );
      return true;
    }
    return false;
  };

  isPrepaidPhotoInvalid = () => {
    if (
      this.state.prepaidCustomer &&
      this.props.event.id !== this.state.prepaidCustomer.eventId
    ) {
      //@ts-ignore
      toastr.error(
        "Your photo pack only applies to the event you purchased it for."
      );
      return true;
    }
    return false;
  };

  shouldShowPrepaidCartPopup = () => {
    return (
      this.state.cart &&
      this.state.cart.eventIds.length >= 1 &&
      !this.state.cart.eventIds.includes(this.props.event.id) &&
      this.prepaidAuthCookie()
    );
  };

  needsPrepaidCustomerCreation = () => {
    return (
      this.props.event.prepaidCustomersEnabled &&
      this.props.event.prepaidCustomersPrimaryAuthField == "cookie" &&
      !this.state.prepaidCustomer
    );
  };

  addAllToCart = async (
    activeFilters: any,
    valArray: Photo[],
    onLoadingChange: (isLoading: boolean) => void
  ) => {
    const cartPhotoIds = this.state.cart?.photos || [];
    const photosToAdd = valArray.filter((photo: Photo) => !cartPhotoIds.includes(photo.id));

    const photoIds: number[] = [];
    photosToAdd.forEach((value: Photo) => {
      photoIds.push(value.id);
    });

    if (photoIds.length === 0) {
      onLoadingChange(false);
      //@ts-ignore
      toastr.info("All photos are already in your cart");
      return;
    }

    if (
      this.isCurrencyMismatch() ||
      this.isBundleDiscountRestricted(photosToAdd[0])
    ) {
      onLoadingChange(false);
      return;
    }

    if (this.shouldShowPrepaidCartPopup()) {
      onLoadingChange(false);

      this.setState({ clearPrepaidCartPopup: true });
      return;
    } else {
      if (this.needsPrepaidCustomerCreation()) {
        const response = await this.handleCookiePrepaidCustomerCreation();
        if (response) {
          this.setState({ photoAddedToCart: photosToAdd[0] });
        }
      }
      ajax
        .post(this.props.addAllToCartAPI)
        .send({
          photo_ids: photoIds,
          activeFilters: activeFilters,
          cart_id: this.state.cart ? this.state.cart.id : null
        })
        .then(res => {
          this.setState(
            {
              cart: res.body.cart
            },
            () => {
              Telemetry.track("event-gallery:add-all-to-cart", {
                eventId: this.props.event.id,
                eventName: this.props.event.name,
                cartId: res.body.cart.id
              });
              onLoadingChange(false);
              //@ts-ignore
              toastr.success("Added to cart", null, { timeOut: 1000 });
              this.checkDiscountAndGetStatus();
              $.getScript(
                withCartIdParam("/cart_sales_count", this.state.cart.id)
              );
            }
          );
        })
        .catch(err => {
          console.log(err);
          onLoadingChange(false);
        });
      if (this.bundleDiscountAvailedFromAnotherEvent(photosToAdd[0])) {
        this.setState(
          {
            cart: {
              ...this.state.cart,
              photoBundleDiscountAvailed: false
            }
          },
          () => this.removePhotoBundleDiscount()
        );
      }
    }
  };

  isCartEmpty = () => {
    if (this.state.cart === null) return true;
    return (this.state.cart.photos?.length || 0) === 0;
  };

  isSaveCartPopupSeen = () =>
    localStorage.getItem("isUserAskedForEmailToSaveCart")
      ? JSON.parse(
          localStorage.getItem("isUserAskedForEmailToSaveCart") as string
        )
      : false;

  canShowEmailPopup = () => {
    const { customerCartEmailEnabled, userSignedIn, event } = this.props;
    const { guestUserId } = this.state;

    const isConditionsMet =
      customerCartEmailEnabled &&
      !guestUserId &&
      this.isCartEmpty() &&
      !userSignedIn;

    if (this.prepaidAuthCookie()) {
      return isConditionsMet;
    } else {
      return (
        isConditionsMet &&
        !this.isSaveCartPopupSeen() &&
        !event.prepaidCustomersEnabled
      );
    }
  };

  printProductsflow = () => {
    return this.props.event.hasPrintProducts;
  };

  showSaveCartModalWithItem = (photo: any, cartItem: any) => {
    this.setState({
      showSaveCartModal: true,
      photoAddedToCart: photo,
      pendingCartItem: cartItem
    });
  };

  afterAddToCart = () => {
    this.checkDiscountAndGetStatus();
    $.getScript(withCartIdParam("/cart_sales_count", this.state.cart.id));
    this.prepaidAuthCookie() && this.handleCookiePrepaidCustomerCreation();
  };

  prepaidAuthCookie = () =>
    this.props.event.prepaidCustomersPrimaryAuthField === "cookie";

  trackCartEmailPopupActions = (eventName: string) => {
    Telemetry.track(eventName, {
      eventId: this.props.event.id,
      eventName: this.props.event.name,
      cartId: this.state.cart ? this.state.cart.id : null
    });
  };

  addPhotoToCart = (photo: any, activeFilters: any) => {
    if (this.isCurrencyMismatch() || this.isBundleDiscountRestricted(photo)) {
      return;
    }
    if (this.shouldShowPrepaidCartPopup()) {
      this.setState({ clearPrepaidCartPopup: true });
      return;
    } else if (this.canShowEmailPopup()) {
      this.setState({
        showSaveCartModal: true,
        photoAddedToCart: photo,
        filterSelection: {
          ...this.state.filterSelection,
          referenceImage: this.state.filterSelection?.referenceImage || null
        }
      });
    } else {
      ajax
        .post(this.props.addToCartAPI)
        .send({
          photo_id: photo.id,
          activeFilters: activeFilters,
          cart_id: this.state.cart ? this.state.cart.id : null
        })
        .then(res => {
          this.setState(
            {
              cart: res.body.cart
            },
            () => {
              this.afterAddToCart();
              this.trackCartEmailPopupActions(
                "event-gallery:cart-email-popup-displayed"
              );
            }
          );
        })
        .catch(err => {
          if (
            err.response &&
            err.response.body &&
            err.response.body.error === "multi_event_cart_error"
          ) {
            //@ts-ignore
            toastr.error(
              "Your cart has photos from a different event. Please clear your cart before adding photos from this event.",
              { timeOut: 6000 }
            );
          } else if (
            err.response &&
            err.response.body &&
            err.response.body.error === "multi_currency_cart_error"
          ) {
            //@ts-ignore
            toastr.error(
              "The cart can only contain photos in one currency. Please clear your cart before adding photos from this event.",
              { timeOut: 6000 }
            );
          } else {
            //@ts-ignore
            toastr.error("Failed to add photo to cart. Please try again.");
          }
        });
      if (this.bundleDiscountAvailedFromAnotherEvent(photo)) {
        this.setState(
          {
            cart: {
              ...this.state.cart,
              photoBundleDiscountAvailed: false
            }
          },
          () => this.removePhotoBundleDiscount()
        );
      }
      //@ts-ignore
      (window.dataLayer || []).push({ event: "addToCart" });
      ahoy.track("albumInteraction", {
        secondary_type: "addToCart",
        photo_id: photo.id,
        album_id: photo.album.id,
        event_id: this.props.event.id
      });
    }
  };

  removePhotoFromCart = (photo: any) => {
    let substitutePrepaidPhoto =
      _.includes(this.state.cart.prepaidPhotos, photo.id) &&
      _.head(
        _.difference(
          this.state.cart.photos || [],
          this.state.cart.prepaidPhotos
        )
      );

    // Optimistically update photos and prepaid photos
    const prevCart = this.state.cart;
    this.setState({
      cart: {
        ...this.state.cart,
        photos: _.without(this.state.cart.photos || [], photo.id),
        prepaidPhotos: _.concat(
          _.without(this.state.cart.prepaidPhotos, photo.id),
          substitutePrepaidPhoto || []
        )
      }
    });

    ajax
      .delete(this.props.removeFromCartAPI)
      .send({ photo_id: photo.id, cart_id: this.state.cart.id })
      .then(res => {
        if (res?.body?.cart) this.setState({ cart: res.body.cart });
        //@ts-ignore
        toastr.success("Removed from cart", null, {
          timeOut: 1000
        });
        this.checkDiscountAndGetStatus();
        $.getScript(withCartIdParam("/cart_sales_count", this.state.cart.id));
      })
      .catch(() => {
        // Revert on failure
        this.setState({ cart: prevCart });
        //@ts-ignore
        toastr.error("Failed to remove from cart. Please try again.");
      });
  };

  updateCartFromApiResponse = (apiResponse: any) => {
    if (apiResponse?.cart) {
      const apiCart = apiResponse.cart;
      const sales = Array.isArray(apiCart.sales) ? apiCart.sales : [];
      // Extract unique photo IDs from all sales
      const photoIds = _.uniq(sales.map((sale: any) => sale.photoId));
      // Extract unique event IDs from sales
      const eventIds = _.uniq(sales.map((sale: any) => sale.eventId));
      // Transform to the expected cart format
      const transformedCart = {
        ...(this.state.cart ?? {}),
        id: apiCart.id,
        currency: apiCart.currency,
        sales_count: sales.length,
        photoBundleDiscountAvailed: apiCart.photoBundleDiscountAvailed,
        photoBundleDiscountEventId:
          apiCart.photoBundleDiscountEventId ??
          this.state.cart?.photoBundleDiscountEventId,
        photos: photoIds as number[],
        eventIds: eventIds as number[],
        // Prefer API prepaidPhotos when present, else preserve existing
        prepaidPhotos: Array.isArray(apiCart.prepaidPhotos)
          ? apiCart.prepaidPhotos
          : this.state.cart?.prepaidPhotos || [],
        sales,
        freeShippingEarned: apiCart.freeShippingEarned ?? false,
        freeShippingAmountNeeded: apiCart.freeShippingAmountNeeded ?? null,
        freeShippingReminderActive: apiCart.freeShippingReminderActive ?? false,
      };
      this.setState({ cart: transformedCart }, () => {
        $.getScript(withCartIdParam("/cart_sales_count", this.state.cart.id));
        // Refresh the discount status + prepaid banners live, matching the
        // legacy add path (afterAddToCart); the lightbox path skipped this.
        this.checkDiscountAndGetStatus();
      });
    }
  };

  emptyPhotosFromCart = async () => {
    let response = await ajax.delete(this.props.emptyCartAPI).send({
      cart_id: this.state.cart ? this.state.cart.id : null
    });
    if (response.status === 200) {
      this.setState({
        cart: response.body.cart
      });
      $.getScript(withCartIdParam("/cart_sales_count", this.state.cart.id));
    }
  };

  emptyPhotosFromPrepaidCart = () => {
    ajax
      .delete(this.props.emptyCartAPI)
      .send({
        cart_id: this.state.cart ? this.state.cart.id : null
      })
      .then((response: any) => {
        this.setState({
          cart: response.body.cart
        });
        $.getScript(withCartIdParam("/cart_sales_count", this.state.cart.id));

        // @ts-ignore
        toastr.success("Your current cart has been cleared.");
      });
  };

  availPhotoBundleDiscount = async () => {
    if (this.state.cart && this.state.cart.id) {
      await this.emptyPhotosFromCart();
    }
    ajax
      .post(this.props.availPhotoBundleDiscountAPI)
      .send({
        cart_id: this.state.cart ? this.state.cart.id : null,
        event_id: this.props.event.id
      })
      .then(res => {
        this.setState({
          cart: {
            ...this.state.cart,
            ...res.body.cart
          }
        });
      });
  };

  removePhotoBundleDiscount = async () => {
    await ajax
      .post(this.props.withdrawPhotoBundleDiscountAPI)
      .send({
        cart_id: this.state.cart.id,
        event_id: this.props.event.id
      })
      .then(res => {
        this.setState({
          cart: {
            ...this.state.cart,
            ...res.body.cart
          }
        });
      })
      .catch(err => console.log(err));
  };

  selfiePrepaidCreateInFlight = false;

  handleSelfiePrepaidCustomerCreation = (referenceImageURL: string) => {
    if (this.selfiePrepaidCreateInFlight) {
      return;
    }

    this.selfiePrepaidCreateInFlight = true;
    this.setState(
      {
        selfiePrepaidStatus: "unavailable"
      },
      () => {
        ajax
          .post(this.props.createPrepaidCustomerAPI)
          .send({
            reference_image_url: referenceImageURL
          })
          .then(res => {
            this.setState({
              cart: res.body.updatedCart,
              prepaidCustomer: res.body.prepaidCustomer,
              prepaidSelfieUrl: res.body.prepaidCustomer ? referenceImageURL : null,
              selfiePrepaidStatus: res.body.prepaidCustomer
                ? "available"
                : "availed"
            });
          })
          .catch(() => {
            this.setState({ selfiePrepaidStatus: "unavailable" });
          })
          .finally(() => {
            this.selfiePrepaidCreateInFlight = false;
          });
      }
    );
  };

  handleCookiePrepaidCustomerCreation = async () => {
    if (!this.props.cookiePrepaidAvailed && !this.state.prepaidCustomer) {
      try {
        const res = await ajax.post(this.props.createPrepaidCustomerAPI).send({
          email: this.state.guestUserId && this.state.guestUserEmail
        });

        return new Promise(resolve => {
          this.setState(
            {
              cart: res.body.updatedCart,
              prepaidCustomer: res.body.prepaidCustomer
            },
            () => {
              resolve(true);
            }
          );
        });
      } catch (error) {
        console.error("Error in handleCookiePrepaidCustomerCreation:", error);
        return false;
      }
    }
    return true;
  };

  unlinkSelfiePrepaidCustomer = () => {
    ajax
      .delete(
        withCartIdParam(this.props.unlinkPrepaidCustomerAPI, this.state.cart.id)
      )
      .then(res => {
        this.setState({
          cart: res.body.updatedCart,
          prepaidCustomer: res.body.prepaidCustomer,
          prepaidSelfieUrl: null,
          selfiePrepaidStatus: "unavailable"
        });
      });
  };

  reportCookieIssue = () => {
    //@ts-ignore
    Rollbar.configure({
      payload: {
        context: "BrowseEvent#event"
      }
    });
    //@ts-ignore
    Rollbar.error("Cookies failing in BrowseEvent", {
      embedded: this.props.embedded
    });

    return true;
  };

  logoutPrepaidCustomer = async (availBundleOffer: boolean) => {
    //@ts-ignore
    toastr.success("Logging you out now...");
    await ajax
      .delete(
        withCartIdParam(this.props.logoutPrepaidCustomerAPI, this.state.cart.id)
      )
      .then(response => {
        const bundleActive = this.state.cart?.photoBundleDiscountAvailed;
        this.setState({
          prepaidCustomer: {} as BrowseEventProps["prepaidCustomer"],
          prepaidSelfieUrl: null,
          cart: this.state.cart ? { ...this.state.cart, prepaidPhotos: [] } : this.state.cart
        });
        if (this.props.event.prepaidCustomersPrimaryAuthField === "selfie") {
          if (!bundleActive) {
            this.eventContainerRef.current?.updateFilters({ referenceImage: null }, false, { skipPrepaidUnlink: true });
          }
        } else if (availBundleOffer && (this.state.cart.photos?.length || 0) > 0) {
          //@ts-ignore
          this.setState({ clearCartPopup: true });
        } else if (
          availBundleOffer &&
          !getCookie("reference_image_for_event")
        ) {
          this.setState({ selfieUploadPopup: true });
        }
      })
      .catch(() =>
        //@ts-ignore
        toastr.failure("Error logging out. Please try again.")
      );
  };

  clearMediaIds = () => this.setState({ listOfMediaId: [] });

  getPhotoId = (
    photo: { id: number; hidden: boolean },
    index: any,
    photos: any
  ) => {
    const listofIDs = [...this.state.listOfMediaId];
    const listOfMedia = [...photos];
    listOfMedia[index].isSelected = true;
    const arrayOfId = listofIDs.filter(i => i.id === photo.id);
    if (arrayOfId.length === 0) {
      listofIDs.push({ id: photo.id, hidden: photo.hidden });
      this.setState({ listOfMediaId: listofIDs });
    } else {
      let indexOfId = -1;
      listofIDs.forEach((i, index) => {
        if (i.id === photo.id) {
          indexOfId = index;
        }
      });
      listOfMedia[index].isSelected = false;
      listofIDs.splice(indexOfId, 1);
      this.setState({ listOfMediaId: listofIDs });
    }
  };

  selectAllVisible = () => {
    let listofIDs: any[] = [];
    if (!this.state.selectAll) {
      this.state.visiblePhotos.forEach((element: any) => {
        element.isSelected = true;
        listofIDs.push({ id: element.id, hidden: element.hidden });
      });
    } else {
      this.state.visiblePhotos.forEach((element: any) => {
        element.isSelected = false;
      });
      listofIDs = [];
    }

    this.setState({
      listOfMediaId: listofIDs,
      selectAll: !this.state.selectAll
    });
  };

  curatePhotos = async () => {
    const { listOfMediaId } = this.state;
    const arrayOfIds = listOfMediaId.map(item => item.id);
    try {
      const res = await $.ajax({
        url: `/api/v1/photos/${this.hideOrUnhideText()}`,
        type: "POST",
        data: {
          photo_ids: arrayOfIds,
          event_id: this.props.event.id
        }
      });

      //@ts-ignore
      toastr.success("Successfully updated");
      Telemetry.track(`event-gallery-curate:${this.hideOrUnhideText()}-photos`);
      this.setState({
        listOfMediaId: [],
        deletePhotosPopup: false,
        selectAll: false,
        reset: true
      });
    } catch (err) {
      //@ts-ignore
      toastr.error("Failed to update");
      console.error(err);
    }
  };

  deletePhotos = async () => {
    const { listOfMediaId } = this.state;
    const arrayOfIds = listOfMediaId.map(item => item.id);
    try {
      const res = await $.ajax({
        url: `/api/v1/photos/delete`,
        type: "DELETE",
        data: {
          photo_ids: arrayOfIds,
          event_id: this.props.event.id
        }
      });

      //@ts-ignore
      toastr.success("Successfully updated");
      Telemetry.track("event-gallery-curate:photos-deleted");
      this.setState({
        listOfMediaId: [],
        selectAll: false,
        reset: true,
        deletePhotosPopup: false
      });
    } catch (err) {
      //@ts-ignore
      toastr.error("Failed to update");
      console.error(err);
    }
  };

  reLoadAlbumPhotos = () => {
    this.setState({ reset: true });
  };

  hideOrUnhideText = () => {
    if (this.state.listOfMediaId.length === 0) return "hide";
    const hideOrUnhide = this.state.listOfMediaId.filter(i =>
      i.hidden != true ? true : false
    );
    return hideOrUnhide.length > 0 ? "hide" : "unhide";
  };

  activeFilters = () => {
    const filters = this.state.filterSelection;
    let activeFilters = [];

    if (filters?.albums && filters.albums.length > 0)
      activeFilters.push("albums");
    if (filters && "favoritesSelected" in filters && filters.favoritesSelected)
      activeFilters.push("favorite");
    if (
      filters &&
      "photographers" in filters &&
      filters.photographers?.length > 0
    )
      activeFilters.push("photographers");
    if (filters && "photoTime" in filters && filters.photoTime?.active)
      activeFilters.push("time");
    if (filters && "photoText" in filters && !!filters.photoText)
      activeFilters.push("bib_number");
    if (filters?.referenceImage) activeFilters.push("selfie");

    return activeFilters;
  };

  setGuestUser = (userId: number, userEmail: string) =>
    this.setState({ guestUserId: userId, guestUserEmail: userEmail });

  setGuestUserCart = async (userId: number, userEmail: string, cart: Cart) => {
    this.setState(
      { guestUserId: userId, guestUserEmail: userEmail, cart: cart },
      async () => {
        this.trackCartEmailPopupActions("event-gallery:cart-email-provided");

        if (this.printProductsflow() && this.state.pendingCartItem) {
          const updates = [this.state.pendingCartItem];
          try {
            const data = await updateCartItems(cart.id, updates);
            if (data?.cart) {
              this.setState({ pendingCartItem: null });
              this.updateCartFromApiResponse(data);
            }
          } catch (error) {
            console.error("Error updating cart:", error);
            //@ts-ignore
            toastr.error("Failed to add item to cart");
          }
        } else if (this.state.photoAddedToCart) {
          this.addPhotoToCart(
            this.state.photoAddedToCart,
            this.activeFilters()
          );
        }
      }
    );
  };

  getReferenceImage = () => {
    const cookie = getCookie("reference_image_for_event");
    const [eventId, referenceImage] = cookie ? cookie.split("-imageURL-") : [];
    const parsedEventId = eventId ? parseInt(eventId) : null;

    if (cookie && parsedEventId != this.props.event.id) {
      //return null if none of these exist or if cookie exists but the event ID doesn't match
      return null;
    } else if (parsedEventId === this.props.event.id && referenceImage) {
      //return reference image if either of the above conditions are true
      return referenceImage;
    }
    return null;
  };

  offerBannerVisible = () => {
    const { event } = this.props;
    const { filterSelection } = this.state;
    const bannerHidden =
      event.prepaidCustomersPrimaryAuthField === "selfie" &&
      event.isPrivate &&
      !filterSelection?.referenceImage;
    return (
      (event.prepaidCustomersEnabled && !bannerHidden) ||
      (event.hasDiscount && event.price !== 0) ||
      event.hasPrintProducts
    );
  };

  showGalleryActions = () => {
    const { isPrivate } = this.props.event;
    const { isProtected, filterSelection } = this.state;

    return (
      (!isProtected && !isPrivate) ||
      (!isProtected && isPrivate && !!filterSelection?.referenceImage)
    );
  };

  closeSaveCartModal = async (shouldAddPhoto = true) => {
    if (shouldAddPhoto && !this.prepaidAuthCookie()) {
      if (this.printProductsflow() && this.state.pendingCartItem) {
        const updates = [this.state.pendingCartItem];

        try {
          const data = await updateCartItems(
            this.state.cart?.id || null,
            updates
          );
          if (data?.cart) {
            this.updateCartFromApiResponse(data);
          }
        } catch (error) {
          console.error("Error updating cart:", error);
          //@ts-ignore
          toastr.error("Failed to add item to cart");
        }
      } else if (this.state.photoAddedToCart) {
        await this.addPhotoToCart(
          this.state.photoAddedToCart,
          this.activeFilters()
        );
      }
    }

    // Always clear the modal and pending state, regardless of shouldAddPhoto
    this.setState({
      showSaveCartModal: false,
      pendingCartItem: null,
      photoAddedToCart: null
    });
  };
  setSaveCartPromptShown = () =>
    localStorage.setItem("isUserAskedForEmailToSaveCart", "true");

  handleNotNowForMandatoryEmail = () => {
    this.setState({
      pendingCartItem: null,
      photoAddedToCart: null
    });
  };

  toggleSideBar = () => {
    this.setState(
      prevState => ({ isSidebarOpen: !prevState.isSidebarOpen }),
      () => {
        const mainContainer = document.getElementById("event-container");
        const fakeButton = document.getElementById("sidebar-arrow-circle");
        if (mainContainer && fakeButton) {
          if (this.state.isSidebarOpen) {
            mainContainer.classList.add("container-small");
            fakeButton.classList.add("open");
          } else {
            mainContainer.classList.remove("container-small");
            fakeButton.classList.remove("open");
          }
        }
      }
    );
  };

  render() {
    return (
      <div id="browse-event">
        <div>
          {this.state.publishState === "unpublished" &&
            this.props.event.canUpdatePrivacy && (
              <PublishBanner
                openPublishPopup={() => this.setState({ publishPopup: true })}
              />
            )}
          <div className="geo-tog-content" style={{ borderBottom: "none", ...(this.offerBannerVisible() ? {} : { paddingBottom: 0 }) }}>
            {/* event name, date, share icon etc */}
            <div className="geo-eg-namewrap">
              <h1>
                <span className="geo-eg-name">
                  {this.state.albumModeID
                    ? this.state.album
                      ? this.state.album[0].name
                      : ""
                    : this.props.event.name}{" "}
                  {!this.props.event.disableEventsSocialSharing && (
                    <span
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        this.setState({ showShareGalleryModal: true })
                      }
                    >
                      <ShareIcon
                        color={this.props.pageConfiguration.primaryColor}
                      />
                    </span>
                  )}
                </span>
              </h1>
              <h6 className="geo-eg-date">
                Event date - {this.props.event.date}
                <div className="geo-csupport__wrap">
                  {this.props.event.supportEmail && (
                    <span
                      className="geo-csupport__icon"
                      onClick={() => this.setState({ showEmailpopup: true })}
                    >
                      <span
                        style={{
                          color: this.props.pageConfiguration.primaryColor
                        }}
                      >
                        {this.props.event.eventSupportLabel
                          ? this.props.event.eventSupportLabel
                          : "Contact Support"}
                      </span>
                    </span>
                  )}
                  {this.state.showEmailpopup && (
                    <div className="geo-popover geo-popover--right">
                      <div
                        className="geo-popover__close"
                        onClick={() => this.setState({ showEmailpopup: false })}
                      >
                        &times;
                      </div>
                      <div className="geo-popover__body">
                        <EventSupportEmailPopup
                          showEmail={this.state.showEmailpopup}
                          closePopup={() =>
                            this.setState({ showEmailpopup: false })
                          }
                          eventSupportLabel={this.props.event.eventSupportLabel}
                          supportEmail={this.props.event.supportEmail}
                        />
                      </div>
                    </div>
                  )}
                </div>
              </h6>
            </div>
            <div className="geo-content-btn">
              {this.showGalleryActions() && this.props.canManageTags ? (
                <div className="tag-mode-tog">
                  {" "}
                  <span
                    className="geo-form__togtext"
                    style={{ marginRight: 5 }}
                  >
                    Curate
                  </span>
                  <label className="switch geo-form__toggle">
                    <input
                      type="checkbox"
                      className="geo-form__toginput"
                      onChange={() =>
                        this.setState(
                          { curationMode: !this.state.curationMode },
                          () =>
                            this.state.curationMode
                              ? this.emptyPhotosFromCart()
                              : this.clearMediaIds()
                        )
                      }
                    />
                    <span
                      className="geo-form__tog"
                      style={
                        this.state.curationMode
                          ? {
                              background:
                                this.props.pageConfiguration.primaryColor
                            }
                          : {}
                      }
                    >
                      <span className="geo-form__tog-in"></span>
                    </span>
                  </label>
                </div>
              ) : (
                this.props.showInvitePhotographerModal && (
                  <div
                    className="invite-ph-box"
                    onClick={() => {
                      Telemetry.track(
                        "internal-referrals:event-gallery-ph-referral"
                      );
                      this.setState({ showInvitePopup: true });
                    }}
                  >
                    <img src={wave} />
                    <span>Are you a photographer?</span>
                  </div>
                )
              )}

              {/* Organisation logo */}
              {this.props.organisationLogo && (
                <div className="geo-org-branding">
                  <img
                    src={this.props.organisationLogo}
                    alt="Organisation Logo"
                  />
                </div>
              )}
            </div>
          </div>
          {this.state.promptPrepaidAuth && (
            <PrepaidCustomerAuthPopup
              event={this.props.event}
              authenticatePrepaidCustomerAPI={
                this.props.authenticatePrepaidCustomerAPI
              }
              setPrepaidCustomer={(prepaidCustomer: any) => {
                this.setState(
                  {
                    prepaidCustomer: prepaidCustomer,
                    promptPrepaidAuth: false
                  },
                  () => this.discountMessage()
                );
              }}
              setUpdatedCart={(updatedCart: any) => {
                this.setState({ cart: updatedCart });
              }}
              cancelPrepaidAuth={() =>
                this.setState({ promptPrepaidAuth: false }, () =>
                  removeParam("prepaid-auth", window.location.href)
                )
              }
              cartId={this.props.cart ? this.props.cart.id : null}
            />
          )}
          {this.showGalleryActions() && this.state.curationMode && (
            <BulkTagging
              showBulkTagging={() => this.setState({ showBulkTagging: true })}
              confirmDelete={() => this.setState({ deletePhotosPopup: true })}
              curatePhotos={this.curatePhotos}
              hideOrUnhideText={this.hideOrUnhideText()}
              selectAllVisible={this.selectAllVisible}
              listOfMediaId={this.state.listOfMediaId}
              filterActive={this.state.filterActive}
              allVisible={this.state.selectAll}
              canDeletePhotos={this.props.canDeletePhotos}
              colorStyling={this.props.pageConfiguration.primaryColor}
            />
          )}
          <EventContainer
            ref={this.eventContainerRef}
            event={this.props.event}
            albumsAPI={this.props.albumsAPI}
            registerCustomerLeadAPI={this.props.registerCustomerLeadAPI}
            userSignedIn={this.props.userSignedIn}
            userId={this.props.userId}
            userEmail={this.props.userEmail}
            cart={this.state.cart}
            addPhotoToCart={this.addPhotoToCart}
            removePhotoFromCart={this.removePhotoFromCart}
            initialFilters={this.props.initialFilters}
            photoTimeRange={this.props.photoTimeRange}
            discountMessage={this.state.discountMessage}
            cartHasDiscount={this.state.cartHasDiscount}
            offerEndsText={this.state.offerEndsText}
            promptPrepaidCustomerAuth={() =>
              this.setState({ promptPrepaidAuth: true })
            }
            emptyPhotosFromCart={this.emptyPhotosFromCart}
            prepaidCustomersEnabled={this.props.event.prepaidCustomersEnabled}
            handleSelfiePrepaidCustomerCreation={
              this.handleSelfiePrepaidCustomerCreation
            }
            logoutPrepaidCustomer={this.logoutPrepaidCustomer}
            selfieSearchS3Bucket={this.props.selfieSearchS3Bucket}
            photoBundleDiscountAvailable={
              this.props.photoBundleDiscountAvailable
            }
            removePhotoBundleDiscount={this.removePhotoBundleDiscount}
            setSelfieUploadPopup={this.setSelfieUploadPopup}
            selfieUploadPopup={this.state.selfieUploadPopup}
            photosAvailable={this.props.photosAvailable}
            curationMode={this.state.curationMode}
            listOfMediaId={this.state.listOfMediaId}
            setFilterActive={this.setFilterActive}
            unlinkSelfiePrepaidCustomer={this.unlinkSelfiePrepaidCustomer}
            clearCartPopup={this.state.clearCartPopup}
            setClearCartPopup={(val: boolean) =>
              this.setState({ clearCartPopup: val })
            }
            guestUserId={this.state.guestUserId}
            availPhotoBundleDiscount={this.availPhotoBundleDiscount}
            showGalleryActions={this.showGalleryActions}
            setAlbum={(val: any) => this.setState({ album: val })}
            album={this.state.album}
            updateCartFromApiResponse={this.updateCartFromApiResponse}
            activeFilters={this.activeFilters}
          />
          {this.props.embedded ? (
            <EmbedHeader cart={this.state.cart} event={this.props.event} />
          ) : null}
          <StyleOverrides
            primaryColor={this.props.pageConfiguration.primaryColor}
            secondaryColor={this.props.pageConfiguration.secondaryColor}
          />
          {this.state.showShareGalleryModal ? (
            <ShareSocialPopup
              galleryURL={this.props.galleryURL}
              hideShareGalleryModal={() =>
                this.setState({ showShareGalleryModal: false })
              }
              text={"Share with participants or just show off ;)"}
            />
          ) : null}
          {this.state.showBulkTagging && (
            <BundleMediaSelect
              listOfMediaId={this.state.listOfMediaId}
              mediaCount={this.state.listOfMediaId.length}
              contentTagsAPI={"/api/v1/content_tags"}
              handleClose={() => this.setState({ showBulkTagging: false })}
              handlePostCall={() => (
                this.clearMediaIds(),
                this.setState({ listOfMediaId: [], selectAll: false })
              )}
            />
          )}
          {this.state.deletePhotosPopup && (
            <DeletePhotosConfirmation
              closePopup={() => this.setState({ deletePhotosPopup: false })}
              deletePhotos={this.deletePhotos}
            />
          )}
          {this.state.clearPrepaidCartPopup && (
            <PromptClearPrepaidCart
              closePopup={() => this.setState({ clearPrepaidCartPopup: false })}
              clearCart={() => {
                this.emptyPhotosFromPrepaidCart();
              }}
              primaryAuth={this.props.event.prepaidCustomersPrimaryAuthField}
            />
          )}
          {this.state.publishPopup && (
            <PublishingOptions
              closePopup={() => this.setState({ publishPopup: false })}
              updateEventPrivacy={(id: number, val: { publish_mode: string }) =>
                this.setState({ publishState: val.publish_mode })
              }
              schoolUser={this.props.schoolUser}
              publicSharingDisabled={this.props.publicSharingDisabled}
              eventPasswordsDisabled={this.props.eventPasswordsDisabled}
              eventData={{
                id: this.props.event.id,
                name: this.props.event.name,
                url: this.props.galleryURL,
                publishMode: this.props.event.publishMode,
                password: ""
              }}
            />
          )}
          {this.state.showSaveCartModal ? (
            <SaveCart
              closeSaveCartModal={this.closeSaveCartModal}
              setSaveCartPromptShown={this.setSaveCartPromptShown}
              setGuestUserCart={this.setGuestUserCart}
              trackCartEmailPopupActions={this.trackCartEmailPopupActions}
              emailMandatory={this.prepaidAuthCookie()}
              onNotNow={this.handleNotNowForMandatoryEmail}
            />
          ) : null}
          {this.state.showInvitePopup && (
            <InvitePhotographerPopup
              handleCloseClick={() => this.setState({ showInvitePopup: false })}
              type={"desktop"}
            />
          )}
        </div>
      </div>
    );
  }
}
